<template>
  <div
    data-testid="message-warning"
    class="flex flex-col gap-4 rounded-lg border-2 p-4 md:px-8"
    :class="props.soft ? 'border-gp-cyan' : 'border-gp-orange bg-gp-orange/20'"
  >
    <div>
      <div class="flex flex-row items-center gap-4">
        <div class="hidden align-top text-3xl sm:flex" :class="props.soft ? 'text-gp-cyan' : 'text-gp-orange'">
          <font-awesome-icon :icon="props.soft ? faCircleInfo : faTriangleExclamation" />
        </div>
        <slot>
          <div class="flex flex-col">
            <slot name="title">
              <div v-if="props.title" class="text-xl font-bold" :class="props.soft ? 'text-gp-cyan' : 'text-gp-orange'">
                {{ props.title }}
              </div>
            </slot>
            <slot name="text">
              <div v-if="props.text" :class="props.soft ? 'text-gp-cyan' : 'text-gp-orange'">
                {{ props.text }}
              </div>
            </slot>
          </div>
        </slot>
      </div>
      <div v-if="isRestart || isBungeecord">
        <div class="flex flex-col gap-4 pt-4 sm:flex-row sm:pl-12">
          <gp-btn
            :btn-type="props.soft ? 'primary' : 'warning'"
            :label="
              isBungeecord ? t('ngp/header/bungeecord/warning/link') : t('ngp/server/update/warning/button/restart')
            "
            size="small"
            @click="isBungeecord ? openBungeecordUrl() : service.restartService(rsid)"
          ></gp-btn>
          <gp-btn
            :label="t('ngp/server/update/warning/button/dismiss')"
            size="sm"
            btn-type="cancel"
            @click="service.setWarningMsg(false)"
          ></gp-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faCircleInfo, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { GpBtn } from "@gportal/uikit";
import { computed } from "vue";
import { useServiceStore } from "@/store/service";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  title?: string;
  text?: string;
  soft?: boolean;
  controls?: string;
}>();

const { t } = useI18n();
const service = useServiceStore();
const serviceNamespace = computed(() => service.ctx.service);
const rsid = computed(() => serviceNamespace.value?.config?.rsid).value;

const isRestart = computed(() => props.controls == "restart");
const isBungeecord = computed(() => props.controls == "bungeecord");

const bungeecordServerUrl = computed(() => service.ctx.profile?.bungeecordServerUrl);
const openBungeecordUrl = () => {
  window.open(bungeecordServerUrl.value, "_blank");
};
</script>
